import styled from 'styled-components';
import { Modal } from 'react-bootstrap';

export const ModalWrapper = styled(Modal)`
  
  
  .modal-dialog {
    max-width: 90%;   /* Largura máxima do modal */
    width: 1200px;    /* Largura fixa para telas grandes */
    margin: auto;
    font-size: 12px !important;
    margin-top: 1.5rem;
    margin-bottom: 1rem;
   
  }

  .modal-content {
    background-color: #f8f9fa;
    border-radius: 10px;
    padding: 10px;
    font-size: 11px !important;
   
  }

  @media (max-width: 768px) {
    .modal-dialog {
      width: 95%;
    }
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  

  nav {
    position: sticky;
    top: 0;
    background: #6e8aad;
    z-index: 10;
    padding: 0.2rem;
    border-radius: 5px;
    border-bottom: 1px solid #ddd;

    ul {
      display: flex;
      justify-content: space-around;
      list-style: none;
      margin: 0;
      padding: 0;
      font-size: 11px !important;
    }

    li {
      padding: 0.2rem 1rem;
      cursor: pointer;
      font-weight: bold;
      color: white;
      transition: background 0.3s;

      &:hover {
        background: rgba(255, 255, 255, 0.2);
      }

      &.active {
        background: white;
        color: #6e8aad;
        border-radius: 5px;
      }
    }
  }

  section {
    flex: 1;
    padding-top: 0.5rem;
    display: grid;
    grid-template-columns: 2fr 3fr;
    gap: 1rem;

    @media screen and (max-width: 1000px) {
      grid-template-columns: 1fr;
      overflow-x: scroll;
    }
    
    .body {
      display: flex;
      flex-direction: column;
      min-height: auto;
      
      .contant {
        flex: 1
      }
    }
    

    .sidebar, .body {
      background: white;
      padding: 0 1rem 1rem 1rem;
      border: 1px solid #ddd;
      border-radius: 5px;


      .divisor {
        color: #888;

        h2 {
          padding: 1rem 0 0 0;
          font-size: 14px;
          color: #888;
          margin-top: 0.7rem;
          
        }

        .marl {
          margin-left: -0.9rem;
          padding-top: 0.2rem;
          padding-bottom: 0.2rem;

          span {
            padding-top: 0.4rem;
          }
          
          .tablet {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
        }
      }
      
      label {
        display: flex;
        justify-content: start;
        margin-bottom: -10px;

        .label {
          font-size: 12px;
          padding: 0 0.3rem;
          flex: 1;
        }
        
        input {
          justify-content: end;
          margin-bottom: -5px;
        }
      }
    }
  }

  footer {
    position: sticky;
    bottom: 0;
    background: #fff;
    display: flex;
    justify-content: space-around;
    padding: 0.4rem;
    border-radius: 5px;
    border: 1px solid #ddd;
    margin-top: 0.5rem;

    button {
      background: #6e8aad;
      color: white;
      padding: 0.5rem 1rem;
      border: none;
      border-radius: 5px;
      transition: background 0.3s;
      font-size: 10px !important;
      font-weight: bold;
      

      &:hover {
        background: #3567a3;
      }
    }
  }

  .navIntern {
    bottom: 0;
    background: #fff;
    display: flex;
    gap: 2rem;
    border-radius: 5px;
    margin-top: 0.5rem;
    position: relative;
    width: 100%;
    padding: 0.5rem 0.5rem 0.8rem 0.5rem;
    border: 1px solid #ddd;
    
    .contentInput {
      display: flex;
      padding-bottom: 0.1rem;
      justify-content: space-between;
      gap: 5rem;
      
      input {
        width: 70px;

        @media screen and (max-width: 1000px) {
          min-width: auto;
        }
      }
      
      .saleName {
        input {
          min-width: 180px;
          
          @media screen and (max-width: 1100px) {
            min-width: 120px;
          }

          @media screen and (max-width: 1000px) {
            min-width: auto;
          }
        } 
      }
    }
    .wrapperProduct {
      display: flex;
      gap: 0.5rem;
    };
    
  }
`;
